import { useEffect, useState } from "react"
import { UsageView } from "../../views"
import { UsageService } from "../../../services"
import moment from "moment"

const UsageAction = () =>{
  const url = process.env.REACT_APP_ETICKET_API
  const usageService = new UsageService(url)
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [usagePart1, setUsagePart1] = useState(null)

  const [dailyTokenUsage, setDailyTokenUsage] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [date, setDate] = useState(parseInt(moment().format('YYYYMM')))

  const monthYearOptions = Array.from({ length: 12 }, (_, i) => {
        const monthDate = moment().subtract(i, 'months')
        const value = parseInt(monthDate.format('YYYYMM'))
        return {
            value,
            text: monthDate.format('MMMM YYYY')
        }
    }).reverse()
  // const [dates, setDates] = useState({ startDate: moment().subtract(1, 'year').toDate(), endDate: moment().toDate()})
  // const [periodType, setPeriodType] = useState("year") // "year" | "month" | "week" | "day"

    const handleChangeDate = (event) => {
        setDate(event.target.value.value)
    }

  const getData = async () => {
    try {
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      // Fetching usage data
      const [usagePart1P, dailyTokenUsageP] = await Promise.all([
            usageService.getUsagePart1Passthrough(yearNumber, monthNumber, token),
            usageService.getDailyTokenUsage(yearNumber, monthNumber, token),
          ])

      setUsagePart1(usagePart1P)
      setDailyTokenUsage(dailyTokenUsageP)
      setIsLoading(false)
    } catch (error) {
      console.error("Error in UsageAction:", error)
    }
  }

  useEffect(() => {
    getData()
  }, [date])
  
  return (
    <UsageView 
      isLoading={isLoading}
      usagePart1={usagePart1}
      dailyTokenUsage={dailyTokenUsage}
      date={date}
      handleChangeDate={handleChangeDate}
      monthYearOptions={monthYearOptions}
    />
  )
}

export { UsageAction as default }